<template>
   <b-row>
    <b-col cols="3" style="border-right: 2px solid #dddddd; min-height: 350px;" class="pt-3 pr-0">
      <b-row>
        <b-col>
          <span class="sg-sub-heading-text p-3">
            Messages
          </span>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-input
            type="text"
            size="sm"
            placeholder="Search"
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col class="mt-3 text-center">
          <i style="font-size: 16px;">You've no message</i>
        </b-col>
      </b-row>
    </b-col>

    <b-col cols="9">
      <b-row style="height: 90%;">
        <b-col>
          <!-- <b-row>
            <b-col class="p-3">
              <b-img
                :src="require('@/assets/img/blank-profile.png')"
                style="width: 50px; height: 50px; border-radius: 50%;"
              />
              Dayu Dwi Deria
              <br>
              <i style="font-size: 12px;">Last seen 14:44</i>
            </b-col>
          </b-row> -->

          <!-- <b-row>
            <b-col>
              asdasd
            </b-col>
          </b-row> -->
        </b-col>
      </b-row>

      <!-- <b-row style="padding-right: 15px;">
        <b-col>
          <b-form-input
            type="text"
            placeholder="Write message..."
          />
        </b-col>
      </b-row> -->
    </b-col>
  </b-row>
</template>

<script>
// external dependencies

// custom component

// api call

export default {
  name: 'Messages',
  props: ['text'],
  data () {
    return {
    }
  },
  methods: {
    // PREREQUISITES
    // END PREREQUISITES

    // HTTP REQUEST
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
.sg-sub-heading-text {
  font-size: 24px;
}

.message-list {
  border-right: 0.1px solid #dddddd;
  width: 100%;
  margin-left: 0;
  padding-left: 0;
  min-height: 500px;

  overflow: scroll;
}

.message-header {
  height: 15%;
}

.message-history {
  height: 80%;
  overflow: scroll
}

.message-form {
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Messages/Messages.vue